
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h13.406l.313.281 6 6 .281.313V29H5V3zm2 2v22h16V11h-6V5H7zm12 1.438v2.563h2.563zM15 13h2l-2 12h-2zm-3.781 2.375l1.563 1.25L10.813 19l1.969 2.375-1.563 1.25-2.5-3L8.188 19l.531-.625zm7.562 0l2.5 3 .531.625-.531.625-2.5 3-1.563-1.25L19.187 19l-1.969-2.375z"}})])
          )
        }
      }
    